import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    this.boundCloseFromEvent = this.closeFromEvent.bind(this)

    // Listen for close events from other dropdowns
    document.addEventListener('dropdown:close-all', this.boundCloseFromEvent)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    // Close all other dropdowns first
    document.dispatchEvent(new CustomEvent('dropdown:close-all', { detail: { except: this.element } }))

    this.menuTarget.classList.remove('hidden', 'opacity-0', 'invisible')
    this.menuTarget.classList.add('opacity-100', 'visible')

    // Listen for clicks outside
    document.addEventListener('click', this.boundHandleClickOutside)
  }

  close() {
    this.menuTarget.classList.remove('opacity-100', 'visible')
    this.menuTarget.classList.add('opacity-0', 'invisible')

    setTimeout(() => {
      this.menuTarget.classList.add('hidden')
    }, 200)

    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  closeFromEvent(event) {
    // Don't close if this is the dropdown that triggered the event
    if (event.detail?.except === this.element) return

    // Only close if currently open
    if (!this.menuTarget.classList.contains('hidden')) {
      this.close()
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside)
    document.removeEventListener('dropdown:close-all', this.boundCloseFromEvent)
  }
}
